
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import { Toast } from 'vant'

export default {
components: {
Tab,
TabItem,
Divider,
Alert
},
data () {
return {
tabIndex:0,
pathCur:0,
model:{appId : this.$route.query.appId,pageSize:10,appPosition:2},
depAppLs:{},
excludesApps:{},
appChildLs:{},
appDbTypes:{},
appComment:{},
belongAppTypes:{},
list:{},
sumEvaluate:0,
patchs:{},
patchNumber:0,
index:0,
loading: false,
finished: false,
status: this.$route.query.status,
show:false,
message:"",
jtotal:-1,
collectFlag:false
}
},
created(){
window.location.href="/m/mall/paas/detail.html?appId="+this.model.appId;






































},
methods: {
goBack(){
window.history.go(-1);




},
appIdToGoods(){
var self=this;
this.$http.post(this.global.httpUrl + '/rest/v1/goods/collection/appIdToGoods',{'appId':this.model.appId,'type':2},{emulateJSON:true}).then(function(res){
if(res.body.success)
{

self.goodsId=res.body.goodsId;
self.addHistory();
self.isCollect();
}else{

}
},function(res){
console.log(res.status);
});
},
addCollection(){
if(!this.goodsId){
console.log('goodsId不存在');
return;
}
var self=this;
this.$http.post(this.global.httpUrl + '/rest/v1/goods/collection/addGoodsCollection',{'goodsId':this.goodsId,'type':2},{emulateJSON:true}).then(function(res){
if(res.body.success)
{
Toast('收藏成功');
self.collectFlag=true;
}else{
Toast('收藏失败：'+res.body.message);
}
},function(res){
console.log(res.status);
});
},
isCollect(){
var self=this;
this.$http.post(this.global.httpUrl + '/rest/v1/goods/collection/isCollect',{'goodsId':this.goodsId,'type':2},{emulateJSON:true}).then(function(res){
self.collectFlag=res.body.success
console.log(self.collectFlag)
},function(res){
console.log(res.status);
});
},
ShowColler(){
this.show=true
this.message="手机端暂不支持此功能。请移步至PC端操作"
},
getAppComment(){
this.tabIndex==1;
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpaas/detail/getEvaluateList',this.model,{emulateJSON:true}).then(function(res){

if(res.body.success)
{
this.appComment=res.body.rows.rows;
if(this.appComment !=undefined){
this.appComment=  this.appComment.replace(/style="[^"]*?"/g,'');
this.appComment= this.appComment.replace(/height="[^"]*?"/g,'');
this.appComment= this.appComment.replace(/width="[^"]*?"/g,'');
this.appComment= this.appComment.replace(/img/g,'img width="100%" ');
}
}
},function(res){
console.log(res.status);
});
},
getPatch(){
this.tabIndex==2;
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpaas/detail/getPatchList',this.model,{emulateJSON:true}).then(function(res){

if(res.body.code!=-1)
{
this.jtotal=0;
this.patchs=res.body.rows;
}
},function(res){
console.log(res.status);
});
},
addHistory(){



this.$http.post(this.global.httpUrl + '/rest/v1/goods/footmark/addGoodsFootMark',{'goodsId':this.goodsId,'type':2},{emulateJSON:true}).then(function(res){
if(res.body.success)
{
console.log('足迹更新成功');
}else{
console.log('足迹更新失败：'+res.body.message);
}
},function(res){
console.log(res.status);
});
},
detailPatch(id) {
this.$router.push({path:'/mall/paas/patchdetail',query:{'appPatchId':id}});
},
onLoad() {

setTimeout(() => {
this.model.pageSize=this.model.pageSize+10;
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpaas/detail/getEvaluateList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.appComment=res.body.rows.rows;

this.loading = false;

if (this.appComment.length >= res.body.rows.total) {
this.finished = true;
}
}
},function(res){
console.log(res.status);
});
}, 500);
},
addClick(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/mdoc/detail/addClickNumber',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{

}
},function(res){
console.log(res.status);
});
}
}
}



// WEBPACK FOOTER //
// ./src/views/mall/paas/detail.vue